import { render, staticRenderFns } from "./TableSSR.vue?vue&type=template&id=2a583999&"
import script from "./TableSSR.vue?vue&type=script&lang=js&"
export * from "./TableSSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports